let token = sessionStorage.getItem("token") ? JSON.parse(sessionStorage.getItem("token")) : {};
 
export const initialState = {
  token: token || {},
  loading: true,
  errorMessage: null
};
 
export const UserReducer = (initialState, action) => {
  switch (action.type) {
    case "CHECK_TOKEN":
      return {
        ...initialState,
        loading: true,
        errorMessage: null
      };
    case "CHECK_TOKEN_SUCCESS":
      return {
        ...initialState,
        token: action.payload,
        loading: false,
        errorMessage: null
      };
  
    case "CHECK_TOKEN_ERROR":
      return {
        ...initialState,
        loading: false,
        errorMessage: action.error
      };

    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};